<template>
    <div class="carBox carBoxLeft">
        <div class="newBox">
        <div class="searchBox">

            <div class="searchGroup">
                <label>所在工程：</label>
                <el-select v-model="search_Obj.f_top_pid" clearable placeholder="请选择" style="width: 200px" @keyup.enter.native="doSearch">
                    <el-option v-for="item in enuObj('project_group')" :key="'project_group'+item.key" :label="item.title" :value="item.key"> </el-option>
                </el-select>
            </div>
            <div class="searchGroup">
                <label>设备编号：</label>
                <el-input v-model="search_Obj.f_device_code" clearable @keyup.enter.native="doSearch"></el-input>
            </div>
            <div class="searchGroup">
                <label>设备类型：</label>
                <el-select v-model="search_Obj.f_device_type" clearable placeholder="请选择" style="width: 200px" @keyup.enter.native="doSearch">
                    <el-option v-for="item in enuObj('device_type4')" :key="'device_type4'+item.key" :label="item.title" :value="item.key"> </el-option>
                </el-select>
            </div>
            <div class="searchGroup">
                <label>上传时间：</label>
                <el-date-picker v-model="dateRange" type="daterange" value-format="yyyy-MM-dd" unlink-panels
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    :picker-options="pickerOptions"
                    @change="dateRangeSet"
                    style="width:420px">
                </el-date-picker>
            </div>
            <el-button type="primary" size="medium" icon="el-icon-search" @click.native="doSearch">搜索</el-button>
        </div>
    <el-card class="box-card">
        <div class="mainBody">
        <div class="btnBox">
            <Btns :menu_id="menu_id" :menus="main_btns" @on_btnclk="btnClick"></Btns>
        </div>
            <div class="dataBox">
                                <el-table :data="tableData" :default-sort="sortData" @sort-change="sortChange" @selection-change="selectChanges" v-loading="loading" border stripe>
                                    <el-table-column prop="top_pid" label="所在工程" sortable="custom">
                                        <template slot-scope="scope">
                                            <span>{{ transEnu(scope.row.top_pid, "project_group") }}</span>
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="device_code" label="设备编号" sortable="custom"></el-table-column>
                                    <el-table-column prop="device_type" label="设备类型" sortable="custom">
                                        <template slot-scope="scope">
                                            <span>{{ transEnu(scope.row.device_type, "device_type4") }}</span>
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="day" label="日期" sortable="custom"></el-table-column>
                                    <el-table-column prop="answers_str" label="巡检结果" sortable="custom"></el-table-column>
                                    <el-table-column prop="check_time" label="巡检时间" sortable="custom"></el-table-column>
                                    <el-table-column prop="add_time" label="上传时间" sortable="custom"></el-table-column>
                                    <el-table-column label="操作" width="120" align="center">
                                        <template slot-scope="scope">
                                            <LabBtns :menu_id="menu_id" :row="scope.row" :index="scope.$index" :menus="lab_btns" @on_btnclk="labelClick"></LabBtns>
                                        </template>
                                    </el-table-column>
                                </el-table>
                            </div>
            <div class="pageBox">
                                <el-pagination background layout="total, sizes, prev, pager, next, jumper" :page-sizes="[10, 20, 50]" :current-page="current" :page-size="pagesize" :total="total" @current-change="pageChange" @size-change="handleSizeChange"></el-pagination>
                            </div>
        </div>
    </el-card>
</div>
        <Edit
                            width="600px"
                            :id="model_id"
                            :title="edit_title"
                            :isshow="editshow"
                            @on-close="closeEditDialog"
                            @on-save-ok="saveOk">
                        </Edit>
                        <Info
                            width="600px"
                            :id="model_id"
                            title="查看设备巡检记录"
                            :isshow="infoshow"
                            @on-close="closeInfoDialog">
                        </Info>
    </div>
</template>

<script>
import Btns from "@/components/common/btns"
import LabBtns from "@/components/common/labbtns"
import Edit from "./edit"
import Info from "./info"
import listutil from "@/libs/listutil"

export default {
    name: 'deviceInspectionLogList',
    mixins: [listutil],
    components: {Edit, Info, Btns, LabBtns},
    data() {
        return {
            m_name: '设备巡检记录',
            menu_id: 3600,
            list_url: "/api/admin/deviceinspectionlog/list",
            search_Obj: {
                f_top_pid: '',
                f_report_id: '',
                f_device_type: '',
                f_device_code: '',
                f_check_time_s_date: '',
                f_check_time_e_date: '',
            },
            del_Obj:{
                url:'/api/admin/deviceinspectionlog/del',
                data:{
                    ids:''
                }
            },
            enu_name: ['device_type4', 'project_group'],
            dateRange: [],
        };
    },
    methods: {
        dateRangeSet(val){
            if(this.$isNotNull(val)){
                this.search_Obj.f_check_time_s_date = val[0]
                this.search_Obj.f_check_time_e_date = val[1]
            }else{
                this.search_Obj.f_check_time_s_date = ''
                this.search_Obj.f_check_time_e_date = ''
            }
        },
    }
};
</script>